import React from 'react';
import { ProgramInfoContainer, ProgramInfoTitleContainer, ProgramInfoTitle } from './ProgramInfo.styles';

const ProgramInfo = ({ title, episodeTitle }) => {
    if (!title || !episodeTitle) {
        return null;
    }

    const text = title === episodeTitle ? title : `${title} – ${episodeTitle}`;

    return (
        <ProgramInfoContainer>
            <ProgramInfoTitleContainer>
                <ProgramInfoTitle data-rt="program-info-title">{text}</ProgramInfoTitle>
            </ProgramInfoTitleContainer>
        </ProgramInfoContainer>
    );
};

export default ProgramInfo;
